const specRows = [
  {
    label: "Capacity",
    icon: "ri-battery-charge-line",
    delta2: "1024Wh",
    deltaPro: "3600Wh",
    river2Pro: "768Wh",
    deltaProUltra: "6144Wh",
  },
  {
    label: "AC Output",
    icon: "ri-plug-line",
    delta2: "1800W",
    deltaPro: "3600W",
    river2Pro: "800W",
    deltaProUltra: "7200W",
  },
  {
    label: "Max Expandable",
    icon: "ri-add-circle-line",
    delta2: "2048Wh",
    deltaPro: "25kWh",
    river2Pro: "1536Wh",
    deltaProUltra: "90kWh",
  },
  {
    label: "Charge to 80%",
    icon: "ri-flashlight-line",
    delta2: "50 min",
    deltaPro: "1.8 hrs",
    river2Pro: "50 min",
    deltaProUltra: "1.5 hrs",
  },
  {
    label: "Battery Cycles",
    icon: "ri-refresh-line",
    delta2: "3,000+",
    deltaPro: "3,500+",
    river2Pro: "3,000+",
    deltaProUltra: "4,000+",
  },
  {
    label: "Weight",
    icon: "ri-scales-3-line",
    delta2: "27 lbs",
    deltaPro: "99 lbs",
    river2Pro: "17.2 lbs",
    deltaProUltra: "154 lbs",
  },
  {
    label: "Solar Input",
    icon: "ri-sun-line",
    delta2: "500W",
    deltaPro: "1600W",
    river2Pro: "220W",
    deltaProUltra: "5600W",
  },
  {
    label: "App Control",
    icon: "ri-smartphone-line",
    delta2: "Wi-Fi + BT",
    deltaPro: "Wi-Fi + BT",
    river2Pro: "Bluetooth",
    deltaProUltra: "Wi-Fi + BT",
  },
  {
    label: "Est. Price",
    icon: "ri-price-tag-3-line",
    delta2: "~$999",
    deltaPro: "~$3,499",
    river2Pro: "~$599",
    deltaProUltra: "~$5,799",
  },
];

const columns = [
  { key: "delta2", label: "DELTA 2", sub: "Best Seller", highlight: false },
  { key: "deltaPro", label: "DELTA Pro", sub: "Most Popular", highlight: true },
  { key: "river2Pro", label: "RIVER 2 Pro", sub: "Most Portable", highlight: false },
  { key: "deltaProUltra", label: "DELTA Pro Ultra", sub: "Flagship", highlight: false },
];

export default function EcoFlowSpecs() {
  return (
    <section className="py-20 px-4 md:px-6 bg-gray-950">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-12">
          <span className="inline-block text-amber-500 text-xs font-bold uppercase tracking-widest mb-3">Side-by-Side</span>
          <h2 className="text-3xl md:text-4xl font-extrabold text-white tracking-tight mb-4">
            Compare EcoFlow Models
          </h2>
          <p className="text-gray-400 text-base max-w-xl mx-auto">
            Not sure which model fits your needs? Here&apos;s how the core lineup stacks up.
          </p>
        </div>

        {/* Table */}
        <div className="overflow-x-auto rounded-xl border border-white/8">
          <table className="w-full min-w-[700px]">
            <thead>
              <tr className="border-b border-white/8">
                <th className="text-left px-5 py-4 text-gray-500 text-xs font-semibold uppercase tracking-wider w-40">
                  Spec
                </th>
                {columns.map((col) => (
                  <th
                    key={col.key}
                    className={`px-5 py-4 text-center ${
                      col.highlight
                        ? "bg-amber-500/10 border-x border-amber-500/20"
                        : ""
                    }`}
                  >
                    {col.highlight && (
                      <span className="block text-amber-400 text-[10px] font-bold uppercase tracking-widest mb-1">
                        Most Popular
                      </span>
                    )}
                    <span className="block text-white font-extrabold text-sm">{col.label}</span>
                    {!col.highlight && (
                      <span className="block text-gray-500 text-[10px] mt-0.5">{col.sub}</span>
                    )}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {specRows.map((row, i) => (
                <tr
                  key={row.label}
                  className={`border-b border-white/5 ${i % 2 === 0 ? "bg-white/2" : ""}`}
                >
                  <td className="px-5 py-3.5">
                    <div className="flex items-center gap-2">
                      <div className="w-5 h-5 flex items-center justify-center">
                        <i className={`${row.icon} text-amber-500 text-sm`}></i>
                      </div>
                      <span className="text-gray-400 text-xs font-medium">{row.label}</span>
                    </div>
                  </td>
                  {columns.map((col) => (
                    <td
                      key={col.key}
                      className={`px-5 py-3.5 text-center ${
                        col.highlight ? "bg-amber-500/8 border-x border-amber-500/15" : ""
                      }`}
                    >
                      <span className={`text-sm font-semibold ${col.highlight ? "text-amber-300" : "text-gray-200"}`}>
                        {row[col.key as keyof typeof row]}
                      </span>
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-10">
          <p className="text-gray-500 text-sm mb-4">
            Not sure which model is right for your home? We&apos;ll help you choose at launch.
          </p>
          <a
            href="#ecoflow-signup"
            onClick={(e) => {
              e.preventDefault();
              document.getElementById("ecoflow-signup")?.scrollIntoView({ behavior: "smooth" });
            }}
            className="inline-flex items-center gap-2 bg-amber-500 hover:bg-amber-400 text-white font-bold text-sm px-7 py-3 rounded-lg transition-colors cursor-pointer whitespace-nowrap"
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-bell-line text-sm"></i>
            </div>
            Get Notified at Launch
          </a>
        </div>
      </div>
    </section>
  );
}
